export default "__VITE_PUBLIC_ASSET__941f51fe__"